import type { LayoutElement } from './types'

/** Mirrors layout.MaxRuleThickness. */
export const MAX_RULE_THICKNESS = 16

/**
 * A line's thickness in canvas units. On paper with none set it is the agent's
 * (internal/slip ruleThickness): the box's cross side up to 8 dots.
 */
export function ruleThickness(el: Pick<LayoutElement, 'w' | 'h' | 'options'>, paper: boolean): number {
  const cross = Math.min(el.w, el.h)
  const set = el.options?.thickness
  if (set && set > 0) return Math.max(1, Math.min(set, cross))
  return paper ? Math.max(1, Math.min(cross, 8)) : Math.max(2, Math.round(cross / 6))
}
